<template>
  <vs-prompt
    color="warning"
    @accept="updateTeamMember"
    @close="close"
    @cancel="close"
    :active.sync="activeUpdatePrompt"
    :title="$t('Team.EditTeamMemberPrompt.Title')"
    :accept-text="$t('Team.EditTeamMemberPrompt.SubmitButton')"
    :cancel-text="$t('Team.EditTeamMemberPrompt.CancelButton')"
  >
    <div>
      <div v-bar class="vs-scrollable">
        <div>
          <div class="con-exemple-prompt px-4 py-3">
            <vs-row>
              <vs-col vs-w="6">
                <vs-input
                
                  :danger-text="$t('Errors.InvalidPolite', {field: $t('Profile.FirstName')})"
                  :label="$t('Profile.FirstName')"
                  v-model="selected.fname"
                  class="w-100 mb-2"
                />
              </vs-col>
              <vs-col vs-w="6">
                <vs-input
                 
                  :danger-text="$t('Errors.InvalidPolite', {field: $t('Profile.LastName')})"
                  :label="$t('Profile.LastName')"
                  v-model="selected.lname"
                  class="w-100 mb-2"
                />
              </vs-col>
            </vs-row>

            <vs-input
             
              :danger-text="$t('Errors.InvalidPolite', {field: $t('Profile.Email')})"
              :label="$t('Profile.Email')"
              v-model="selected.email"
              class="w-100 mb-2"
            />
            <vs-input
              
              :danger-text="$t('Errors.InvalidPolite', {field: $t('Profile.PhoneNumber')})"
              :label="$t('Profile.PhoneNumber')"
              v-model="selected.telephone"
              class="w-100 mb-2"
            />

            <vs-select
              class="w-100 mb-2"
              :danger-text="$t('Errors.InvalidPolite', {field: $t('Profile.Role')})"
              :label="$t('Profile.Role')"
              v-model="selected.role"
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item,index) in positions"
              />
            </vs-select>

            <vs-select
              class="w-100 mb-2"
              :label="$t('Profile.Department')"
              v-if="departments.length"
              v-model="selected.department_id"
            >
              <vs-select-item
                :key="index"
                :value="item.id"
                :text="item.name"
                v-for="(item,index) in departments"
              />
            </vs-select>

            <vs-row>
              <vs-col vs-w="3">
                <vs-avatar
                  class="mt-3"
                  :src="selected.photo ? selected.photo : require('@/assets/images/users/1.jpg')"
                  size="64px"
                ></vs-avatar>
              </vs-col>
              
            </vs-row>
          </div>
        </div>
      </div>
    </div>
  </vs-prompt>
</template>
<script>
import { teamService } from "../../_services" 
export default {
  name: "edit",
  data: () => ({
    title: "edit",
    positions: [],
    departments: [],
    errors: {
      fname: false,
      lname: false,
      telephone: false,
      email: false,
      password: false,
      password_confirm: false,
      role: false,
      selected: {
        fname: false,
        lname: false,
        telephone: false,
        email: false,
        password: false,
        password_confirm: false,
        role: false
      }
    }
  }),
  props: {
    activeUpdatePrompt : Boolean,
    selected : Object
  },
  methods: {

    close() {
      this.member.fname = "";
      this.member.name = "";
      this.member.telephone = "";
      this.member.email = "";
      this.member.password = "";
      this.member.password_confirm = "";
      this.member.role = "";
      this.activePrompt=false;
    },
updateTeamMember(){
 teamService.update(selected).then(function(data){
  
  console.log(data)
  console.log("updated account ");


})
this.activeUpdatePrompt=false;

}



  }
  ,mounted(){
   console.log(this.selected);
  



  }
};
</script>